import type { UseFormReturn } from 'react-hook-form';
import { Checkbox, Labeled } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';
import { Link } from '~/components/atoms/Link';

export type INewTermsOfServicesFormMainSectionFormValues = {
  termsOfServiceAgreement: boolean;
  userLicenceAgreement: boolean;
};

export type INewTermsOfServicesFormMainSectionProps = IContainerProps & {
  form: UseFormReturn<INewTermsOfServicesFormMainSectionFormValues>;
};

export const NewTermsOfServicesFormMainSection: React.FC<
  INewTermsOfServicesFormMainSectionProps
> = (props) => {
  const { sx, form } = props;
  const { t } = useTranslation();

  return (
    <FormSection sx={sx}>
      <Labeled
        label={
          <>
            {t('NewTermsOfServicesFormMainSection.i-agree-to')}
            &nbsp;
            <Link
              target="_blank"
              to="https://crowdaa-tos.s3.us-east-1.amazonaws.com/crowdaa-dashboard/20250805-CROWDAA_TOS.pdf"
            >
              {t('NewTermsOfServicesFormMainSection.terms-of-service')}
            </Link>
          </>
        }
        labelPosition="right"
        required
      >
        <FormField
          name="termsOfServiceAgreement"
          control={form.control}
          as={Checkbox}
        />
      </Labeled>
      <Labeled
        label={
          <>
            {t('NewTermsOfServicesFormMainSection.i-agree-to')}&nbsp;
            <Link
              target="_blank"
              to="https://crowdaa-tos.s3.us-east-1.amazonaws.com/crowdaa-dashboard/20250805-CROWDAA_CGU.pdf"
            >
              {t('NewTermsOfServicesFormMainSection.user-license')}
            </Link>
          </>
        }
        labelPosition="right"
      >
        <FormField
          name="userLicenceAgreement"
          control={form.control}
          as={Checkbox}
          required
        />
      </Labeled>
    </FormSection>
  );
};
